import React from "react";
import BlogFortySix from "../component/BlogFortySix";

function BlogFortySixContainer() {
  return <BlogFortySix />;
}

export default BlogFortySixContainer;
